var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"focus:outline-none focus:border-none",on:{"click":_vm.activateTVMode}},[(
      _vm.pollTVData &&
      _vm.pollTVData.comment &&
      _vm.pollTVData.comment.text === _vm.comment.text
    )?_c('img',{staticClass:"w-6 ml-2 text-white",attrs:{"src":require("@/assets/tv-icon-on.png"),"alt":"TV Mode"}}):_c('img',{staticClass:"w-6 ml-2 text-white",attrs:{"src":require("@/assets/tv-icon-off.png"),"alt":"TV Mode"}})])}
var staticRenderFns = []

export { render, staticRenderFns }